import {
    message,
    PageHeader,
    Spin,
    Select,
    Row,
    Col,
    Input,
    Alert,
    Modal,
    Tooltip,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import {
    Form,
    FormItem,
    SelectItem,
    InputNumberItem,
    cuentaMask,
    DatePickerItem,
    round2Decimals,
    NotificacionPolizas,
    InputItem,
    ButtonItem,
    ErrorItem,
    SegmentedItem,
  } from "../../../../Components/Items";
  import { cuadrePorProyecto, mensajeDescuadrePorProyecto } from "../../../../Utils/cuadrePoliza";
  import TotalesCuadrePoliza from "../../../../Components/TotalesCuadrePoliza";
  import { PlusOutlined, DeleteOutlined, CopyOutlined } from "@ant-design/icons";
  import moment from 'moment'
import AgregarTipoDePoliza from "../../TiposDePolizas/AgregarTipoDePoliza/AgregarTipoDePoliza";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";

  const { Option } = Select;
  
  class EditarPoliza extends Component {
    formRef = React.createRef();
    state = {
      loading: false,
      objetoProveedores: null,
      todasProveedores: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoInsumos: null,
      todasInsumos: null,
      todasTiposDePolizas: null,
      objetoTiposDePolizas: null,
      todasCuentaContable: null,
      objetoCuentaContable: null,
      modalAgregarTipoDePoliza: false,
      modalAgregarCuentaContable: false,
      filaCuentaContable: null,
      impuestos: [],
      proyectosConSubproyectos : false,
      objetoSubproyectos: null,
      esManual: true,
      // Modo "varios proyectos": cada renglon lleva su propio proyecto y cada proyecto tiene
      // que cuadrar por separado. Se enciende solo si la poliza ya viene repartida.
      multiProyecto: false,
    };
    componentDidMount() {
      this.consultarTodo();
    }
    // Puede venir de la ruta (/panel/editarPolizaManual) o como prop cuando se
    // monta embebido dentro de un modal desde un reporte.
    polizaId() {
      return this.props.polizaId || this.props.location?.state?.id;
    }
    async consultarTodo() {
      this.setState({ loading: true });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
        await this.consultarCuentasContables();
        await axios
        .post(
          "tiposdepolizas/selectTiposDePolizas",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasTiposDePolizas: res.data });
            this.setState({
              objetoTiposDePolizas: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + " - " + value.descripcion}
                  </Option>
                );
              }),
            });
          }
        });
        await axios
        .post(
          "polizas/datosPolizaManual",
          { empresaId: this.props.empresaId, polizaId: this.polizaId() },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.error("Error no se encontro informacion de la poliza");
          } else {
            const polizaData = res.data;
            // datosPolizaManual devuelve el CargoAbono completo, asi que cada renglon ya trae
            // su proyectoId. Si la poliza esta repartida entre varios proyectos (el caso de
            // nomina), se abre directo en modo multi y muestra el desglose de cuadre.
            const proyectosDistintos = new Set(
              (polizaData.cargosAbonos || [])
                .filter(Boolean)
                .map((valueCA) => `${valueCA.proyectoId || ""}`)
            );
            const multiProyecto = proyectosDistintos.size > 1;
            this.setState({ esManual: !!polizaData.manual, multiProyecto });
            this.formRef.current?.setFieldsValue({
              ...polizaData,
              fechaPoliza: moment(res.data.fechaRegistro),
            });

            if (!multiProyecto && this.state.todasProyectos && polizaData.proyectoId) {
              const proyectoActivo = this.state.todasProyectos.find(
                (p) => p._id === polizaData.proyectoId
              );

              if (proyectoActivo && proyectoActivo.subProyectos?.length > 0) {
                this.setState({
                  proyectosConSubproyectos: true,
                  objetoSubproyectos: proyectoActivo.subProyectos.map((sp) => (
                    <Option key={sp._id} value={sp._id}>
                      {sp.codigo + " - " + sp.nombre}
                    </Option>
                  )),
                });
              }
            }
          }
        });
      this.setState({ loading: false });
    }
    async consultarCuentasContables() {
      await axios
        .post(
          "cuentascontables/selectCuentasContablesFinales",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasCuentaContable: res.data });
            this.setState({
              objetoCuentaContable: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.descripcion}
                  </Option>
                );
              }),
            });
          }
        });
    }
    atras() {
      // Embebido en un modal no hay a donde regresar: se cierra el modal.
      if (this.props.onCerrar) return this.props.onCerrar();
      this.props.history.goBack();
    }
    onFinishFailed(e) {
      ErrorItem(e);
    }
    onFinish(values) {
        if(!values.cargosAbonos){
          message.error("No hay cargos y abonos");
          return;
        }
        // Con varios proyectos no basta con que el total global cuadre: cada proyecto tiene
        // que cuadrar por su cuenta, que es lo que da por hecho el desglose del PDF.
        const grupos = cuadrePorProyecto(values.cargosAbonos, values.proyectoId)
        if (this.state.multiProyecto) {
          const mensaje = mensajeDescuadrePorProyecto(grupos, this.nombreProyecto.bind(this))
          if (mensaje) return message.error(mensaje)
        } else {
          const total = grupos.reduce((suma, grupo) => round2Decimals(suma + grupo.diferencia), 0)
          if (Math.abs(total) !== 0) return message.info('Los cargos y abonos deben coincidir')
        }
      this.setState({ loading: true });
      axios
        .post(
          "polizas/editarPolizaManual",
          {
            ...values,
            empresaId: this.props.empresaId,
            polizaId: this.polizaId(),
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success(
              "Se ha editado una poliza"
            );
            NotificacionPolizas(res.data.polizasId)
            this.formRef.current.resetFields();
            if (this.props.onGuardado) this.props.onGuardado();
            this.atras(res.data.codigo);
          } else if (res.data.success === 1) {
            message.error(res.data.mensaje || "No se pudo editar la poliza");
          } else {
            message.error("Hubo un error y la poliza no se edito");
          }
        });
    }
    abrirAgregarTipoDePoliza() {
        this.setState({ modalAgregarTipoDePoliza: true });
      }
    cerrarAgregarTipoDePoliza(codigo) {
      this.setState({ modalAgregarTipoDePoliza: false });
      this.consultarTodo();
    }
    abrirAgregarCuentaContable(arrayKey) {
      this.setState({ modalAgregarCuentaContable: true, filaCuentaContable: arrayKey });
    }
    cerrarAgregarCuentaContable(codigo) {
      const filaCuentaContable = this.state.filaCuentaContable;
      this.setState({ modalAgregarCuentaContable: false, filaCuentaContable: null });
      this.consultarCuentasContables().then(() => {
        if (typeof codigo === "string" && filaCuentaContable !== null) {
          const cargosAbonos = this.formRef.current.getFieldValue("cargosAbonos") || [];
          cargosAbonos[filaCuentaContable] = {
            ...cargosAbonos[filaCuentaContable],
            cuentaContableId: codigo,
          };
          this.formRef.current.setFieldsValue({ cargosAbonos });
        }
      });
    }

    onChangeProyecto(value){
      // Con varios proyectos el subproyecto del encabezado no aplica.
      if (this.state.multiProyecto) {
        this.setState({ proyectosConSubproyectos: false, objetoSubproyectos: [] });
        return;
      }
      const proyecto = this.state.todasProyectos?.find(
        (valueP) => valueP._id === value
      );
      if (
        proyecto &&
        Array.isArray(proyecto.subProyectos) &&
        proyecto?.subProyectos?.length > 0
      ) {
        this.setState({
          proyectosConSubproyectos: true,
          objetoSubproyectos: proyecto.subProyectos.map((value) => (
            <Option key={value._id} value={value._id}>
              {value.codigo + " - " + value.nombre}
            </Option>
          )),
          
        });
      }
      else{
        this.setState({
          proyectosConSubproyectos: false,
          objetoSubproyectos: []
        })
      }
    }

    // Nombre para el desglose y los mensajes de error.
    nombreProyecto(proyectoId) {
      const proyecto = this.state.todasProyectos?.find(
        (valueP) => valueP._id === proyectoId
      );
      return proyecto?.nombre || "Sin proyecto";
    }

    cambiarModoProyecto(valor) {
      const multiProyecto = valor === 1;
      const proyectoId = this.formRef.current.getFieldValue("proyectoId");

      // Renglones nuevos, nunca el mismo array: setFieldsValue con la misma referencia no
      // notifica a los shouldUpdate de la tabla y la columna se queda en blanco.
      const reescribir = (forzar) =>
        (this.formRef.current.getFieldValue("cargosAbonos") || []).map((valueCA) =>
          valueCA
            ? { ...valueCA, proyectoId: forzar ? proyectoId : valueCA.proyectoId || proyectoId }
            : valueCA
        );

      if (multiProyecto) {
        // El subproyecto pertenece a un proyecto: con varios ya no hay uno solo al que
        // referirse. Va null explicito para que el backend lo limpie.
        this.formRef.current.setFieldsValue({
          cargosAbonos: reescribir(false),
          subProyectoId: null,
        });
        this.setState({ multiProyecto: true, proyectosConSubproyectos: false });
        return;
      }

      const proyectosDistintos = new Set(
        (this.formRef.current.getFieldValue("cargosAbonos") || [])
          .filter(Boolean)
          .map((valueCA) => valueCA.proyectoId)
      );

      const volverASimple = () => {
        this.formRef.current.setFieldsValue({ cargosAbonos: reescribir(true) });
        this.setState({ multiProyecto: false }, () => this.onChangeProyecto(proyectoId));
      };

      if (proyectosDistintos.size > 1) {
        Modal.confirm({
          title: "Regresar a un solo proyecto",
          content:
            "Los renglones tienen proyectos distintos. Todos van a pasar al proyecto del encabezado.",
          okText: "Continuar",
          cancelText: "Cancelar",
          onOk: volverASimple,
        });
        return;
      }

      volverASimple();
    }

    // El concepto del encabezado casi siempre se repite en cada movimiento, asi que este boton
    // lo copia de un jalon en vez de teclearlo renglon por renglon.
    copiarConceptoATodos() {
      const concepto = this.formRef.current.getFieldValue("concepto");
      if (!concepto) return message.info("Primero captura el concepto de la poliza");

      const cargosAbonos = this.formRef.current.getFieldValue("cargosAbonos") || [];
      if (cargosAbonos.length === 0) return message.info("No hay cargos y abonos");

      // Renglones nuevos, nunca el mismo array: setFieldsValue con la misma referencia no
      // notifica a los shouldUpdate de la tabla y la columna se queda en blanco. Los renglones
      // recien agregados valen undefined hasta que se teclea algo, de ahi el objeto nuevo.
      const copiar = () => {
        this.formRef.current.setFieldsValue({
          cargosAbonos: cargosAbonos.map((valueCA) =>
            valueCA ? { ...valueCA, concepto } : { concepto }
          ),
        });
        message.success("Concepto copiado a " + cargosAbonos.length + " movimientos");
      };

      // Solo se pregunta cuando hay conceptos distintos capturados a mano, que es lo unico
      // que se perderia.
      const pisaCapturados = cargosAbonos.some(
        (valueCA) => valueCA?.concepto && valueCA.concepto !== concepto
      );
      if (pisaCapturados) {
        return Modal.confirm({
          title: "Copiar el concepto a todos los movimientos",
          content: "Hay renglones con un concepto distinto y se va a reemplazar.",
          okText: "Continuar",
          cancelText: "Cancelar",
          onOk: copiar,
        });
      }

      copiar();
    }

    // Las columnas se arman en cada render: TabbedDynamicTable no memoiza nada, y la de
    // Proyecto solo existe en modo multi. El numero de columnas tiene que empatar con el de
    // <td> de renderCargoAbonoRow en las dos ramas, porque la alineacion es posicional.
    getCargosAbonosColumns() {
      const multi = this.state.multiProyecto;
      const columnas = [
        { title: "Cuenta Contable", width: multi ? "20%" : "25%" },
        { title: "Cargo", width: multi ? "14%" : "18%" },
        { title: "Abono", width: multi ? "14%" : "18%" },
        { title: "Concepto", width: multi ? "24%" : "25%" },
        { title: "Acciones", width: multi ? "12%" : "14%" },
      ];
      if (multi) columnas.splice(1, 0, { title: "Proyecto", width: "16%" });
      return columnas;
    }

    renderCargoAbonoRow({ key, name, fieldKey: _fieldKey, restField, arrayKey, remove }) {
      return (
        <tr key={key}>
          <td className="td-border">
            <Input.Group compact style={{ display: "flex" }}>
              <FormItem
                {...restField}
                name={[name, "cuentaContableId"]}
                fieldKey={[arrayKey, "cuentaContableId"]}
                required
                noStyle
              >
                <SelectItem
                  sinBorde
                  autoFocus
                  style={{ flex: 1, minWidth: 0 }}
                  placeholder="Cuenta"
                >
                  {this.state.objetoCuentaContable}
                </SelectItem>
              </FormItem>
              {/* Ancho fijo en px, no en %: con 15% de una celda angosta el icono no cabia.
                  La clase le devuelve el tamaño que `.tabla-compacta td *` le quita. */}
              {this.props.permisoAgregarCuentaContable && (
                <ButtonItem
                  blanco
                  className="boton-icono-celda"
                  icon={<PlusOutlined />}
                  style={{ width: 34 }}
                  onClick={() => this.abrirAgregarCuentaContable(arrayKey)}
                />
              )}
            </Input.Group>
          </td>
          {this.state.multiProyecto && (
            <td className="td-border">
              <FormItem
                shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId}
                noStyle
              >
                {({ getFieldValue }) => (
                  <FormItem
                    {...restField}
                    name={[name, "proyectoId"]}
                    fieldKey={[arrayKey, "proyectoId"]}
                    required
                    noStyle
                    initialValue={getFieldValue("proyectoId")}
                  >
                    <SelectItem
                      sinBorde
                      width="100%"
                      placeholder="Proyecto"
                    >
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                )}
              </FormItem>
            </td>
          )}
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const arrayCargosAbonos = getFieldValue('cargosAbonos')
                const disabled = arrayCargosAbonos[arrayKey] ? arrayCargosAbonos[arrayKey].abono : false
                return (
                  <FormItem
                    {...restField}
                    name={[name, "cargo"]}
                    fieldKey={[arrayKey, "cargo"]}
                    required={!disabled}
                    number
                    noStyle
                    initialValue={undefined}
                  >
                    <InputNumberItem sinBorde disabled={disabled} dinero />
                  </FormItem>
                )
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const arrayCargosAbonos = getFieldValue('cargosAbonos')
                const disabled = arrayCargosAbonos[arrayKey] ? arrayCargosAbonos[arrayKey].cargo : false
                return (
                  <FormItem
                    {...restField}
                    name={[name, "abono"]}
                    fieldKey={[arrayKey, "abono"]}
                    required={!disabled}
                    number
                    noStyle
                    initialValue={undefined}
                  >
                    <InputNumberItem sinBorde disabled={disabled} dinero />
                  </FormItem>
                )
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "concepto"]}
              fieldKey={[arrayKey, "concepto"]}
              required
              noStyle
            >
              <InputItem sinBorde />
            </FormItem>
          </td>
          <td className="td-border-sin-right">
            <Row className="acciones-container">
              <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
                <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                  <ButtonItem
                    rojo2
                    icon={<DeleteOutlined />}
                    onClick={() => remove(name)}
                    size="small"
                  />
                </Tooltip>
              </Col>
            </Row>
          </td>
        </tr>
      );
    }

    getObservacionesConfig() {
      return {
        totales: (
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => (
              <TotalesCuadrePoliza
                cargosAbonos={getFieldValue("cargosAbonos")}
                proyectoId={getFieldValue("proyectoId")}
                multiProyecto={this.state.multiProyecto}
                nombreProyecto={this.nombreProyecto.bind(this)}
              />
            )}
          </FormItem>
        ),
      };
    }

    render() {
      return (
        <>
          {!this.props.embedded && (
            <PageHeader
              onBack={this.atras.bind(this)}
              title="Editar Poliza"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
            />
          )}
          <div className="card-background">
            <Spin spinning={this.state.loading}>
              {!this.state.esManual && (
                <Alert
                  type="warning"
                  showIcon
                  message="Esta póliza se generó automáticamente. Si son cambios mínimos no hay problema, pero te recomendamos mejor modificar el movimiento que la originó en lugar de editar la póliza directamente."
                  style={{ marginBottom: 15 }}
                />
              )}
              <Form
                ref={this.formRef}
                name="editarPoliza"
                layout
                onFinish={this.onFinish.bind(this)}
                onFinishFailed={this.onFinishFailed}
              >
                <GeneralFormLayout
                  cards={[
                    {
                      title: "Datos Generales",
                      content: (
                        <Row gutter={[16, 0]}>
                          <Col span={12}>
                            <div style={{ marginBottom: 10 }}>
                              <SegmentedItem
                                options={[
                                  { label: "Un proyecto", value: 0 },
                                  { label: "Varios proyectos", value: 1 },
                                ]}
                                value={this.state.multiProyecto ? 1 : 0}
                                onChange={this.cambiarModoProyecto.bind(this)}
                              />
                            </div>
                            <FormItem
                              label={this.state.multiProyecto ? "Proyecto principal" : "Proyecto"}
                              name="proyectoId"
                              margin
                              required
                            >
                              <SelectItem placeholder="Proyecto" onChange={(value) => this.onChangeProyecto(value)}>
                                {this.state.objetoProyectos}
                              </SelectItem>
                            </FormItem>
                            {!this.state.multiProyecto && this.state.proyectosConSubproyectos && (
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  let proyectoId = getFieldValue("proyectoId");
                                  if (!proyectoId) return null;
                                  return (
                                    <FormItem
                                      label="Subproyecto"
                                      name="subProyectoId"
                                      margin
                                    >
                                      <SelectItem
                                        placeholder="Subproyecto"
                                        allowClear
                                      >
                                        {this.state.objetoSubproyectos}
                                      </SelectItem>
                                    </FormItem>
                                  );
                                }}
                              </FormItem>
                            )}
                            <FormItem
                              label="Tipo de Poliza"
                              margin
                            >
                              <Input.Group compact>
                                <FormItem name="tipoDePolizaId" required noStyle>
                                  <SelectItem
                                    placeholder="Tipo de Poliza"
                                    width={this.props.empresaExterna ? "100%" : "80%"}
                                  >
                                    {this.state.objetoTiposDePolizas}
                                  </SelectItem>
                                </FormItem>
                                {!this.props.empresaExterna && (
                                  <ButtonItem
                                    blanco
                                    icon={<PlusOutlined />}
                                    style={{ width: "20%" }}
                                    onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                                  />
                                )}
                              </Input.Group>
                            </FormItem>
                          </Col>
                          <Col span={12}>
                            <FormItem
                              label="Fecha de Poliza"
                              name="fechaPoliza"
                              required
                              margin
                              initialValue={moment()}
                            >
                              <DatePickerItem
                                placeholder="Fecha de Poliza"
                                allowClear={false}
                              />
                            </FormItem>
                            <FormItem label="Concepto" margin>
                              <Input.Group compact>
                                <FormItem
                                  name="concepto"
                                  pattern
                                  required
                                  noStyle
                                >
                                  <InputItem placeholder="Concepto" width="80%" />
                                </FormItem>
                                <Tooltip title="Copiar el concepto a todos los movimientos">
                                  <ButtonItem
                                    blanco
                                    icon={<CopyOutlined />}
                                    style={{ width: "20%" }}
                                    onClick={this.copiarConceptoATodos.bind(this)}
                                  />
                                </Tooltip>
                              </Input.Group>
                            </FormItem>
                          </Col>
                        </Row>
                      ),
                    },
                  ]}
                  tabsConfig={{
                    tabs: [
                      {
                        key: "cargosAbonos",
                        label: "Cargos y Abonos",
                        listName: "cargosAbonos",
                        minWidth: this.state.multiProyecto ? "950px" : "700px",
                        columns: this.getCargosAbonosColumns(),
                        renderRow: (rowProps) => this.renderCargoAbonoRow(rowProps),
                        renderFooter: ({ add }) => (
                          <FormItem noStyle>
                            <ButtonItem
                              type="primary"
                              cyan
                              block
                              hotkey="alt+a"
                              style={{ marginTop: 10 }}
                              icon={<PlusOutlined />}
                              onClick={() => add()}
                            >
                              Agregar Campo
                            </ButtonItem>
                          </FormItem>
                        ),
                      },
                    ],
                  }}
                  observacionesConfig={this.getObservacionesConfig()}
                  totalesMaxWidth={this.state.multiProyecto ? "70%" : "35%"}
                  actionButtons={
                    // Embebida en ModalEditarPoliza el hotkey se registraria en window sin
                    // scope al modal, o sea que quedaria vivo sobre la pagina de atras.
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      cyanB
                      hotkey={this.props.embedded ? undefined : "shift+e"}
                      style={{ width: "5%" }}
                    >
                      Editar
                    </ButtonItem>
                  }
                />
              </Form>
            </Spin>
          </div>
          <AgregarTipoDePoliza
          visible={this.state.modalAgregarTipoDePoliza}
          cerrarAgregarTipoDePoliza={this.cerrarAgregarTipoDePoliza.bind(this)}
        />
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        </>
      );
    }
  }

  // ownProps.empresaId gana sobre la de la sesion: las herramientas internas de Biwo montan
  // esta pantalla desde el PanelPrincipal para operar sobre la empresa de un cliente, donde
  // state.empresa.id es la empresa del propio usuario Biwo. Tiene que leerse aqui y no basta
  // con pasar la prop, porque connect deja ganar a los stateProps sobre los ownProps.
  const mapStateToProps = (state, ownProps) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: ownProps.empresaId || state.empresa.id,
      // Los modales de "agregar" crean el catalogo en la empresa de la sesion, asi que no se
      // ofrecen cuando se esta trabajando sobre la empresa de otro.
      permisoAgregarCuentaContable: !ownProps.empresaId && (state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cda85f30e81b54183cf9d")?.activado),
      empresaExterna: !!ownProps.empresaId,
    };
  };
  
  export default connect(mapStateToProps)(EditarPoliza);
  